import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const StackBarChartPanel = (props) => {
const {_data} = props;
const [hoveredBarIndex, setHoveredBarIndex] = useState(null);

const handleMouseEnter = (index) => {
  setHoveredBarIndex(index);
};

const handleMouseLeave = () => {
  setHoveredBarIndex(null);
};

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={300}
        data={_data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 0,
        }}
      >
         <CartesianGrid
            strokeDasharray="3 3"
            vertical={false}
          />
        <XAxis
          dataKey="date"
          tick={{
            fontSize: 12,
            fill: "#000"
          }}
        />
        <YAxis
          tick={{
            fontSize: 12,
            fill: "#000"
          }}
          label={{ value: 'Person', angle: -90, position: 'insideLeft', fill: "#000", fontSize: 12 }}
        />
        <Tooltip cursor={{ fill: 'transparent' }}/>
        <Legend style={{textTransform:'capitalize'}}/>
        <Bar
          dataKey="bettedUser"
          stackId="a"
          fill="#365f94"
          opacity={(hoveredBarIndex === null || hoveredBarIndex === 1 ? 1 : 0.25)}
          onMouseEnter={() => handleMouseEnter(0)}
          onMouseLeave={handleMouseLeave}
        />
        <Bar
          dataKey="loggedUser"
          stackId="a"
          fill="#bbcce2"
          opacity={(hoveredBarIndex === null || hoveredBarIndex === 1 ? 1 : 0.25)}
          onMouseEnter={() => handleMouseEnter(1)}
          onMouseLeave={handleMouseLeave}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default StackBarChartPanel;
